import React, { useEffect, useState } from "react";
import "./Menu.css";
import { Button, Flex, message, Modal, Popconfirm, Spin } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import Empty from "../SVGs/Empty";
import Plates from "../Plates/plates";
import deleteIcon from "../../Images/Delete.svg";
import { MenuService, MenuOfTheDayService } from "deliziora-client-module/client-web";

const MenuCalendar = ({ selectedDay, Day }) => {
  const [showModal, setShowModal] = useState(false);
  const [plates, setPlates] = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [isDeleted, setIsDeleted] = useState(false);
  const [isAdded, setIsAdded] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [allMenuRes, menuOfDayRes] = await Promise.all([
          MenuService.returnAllMenu(),
          MenuOfTheDayService.returnAllMenuOfDayByRestaurant(userData._id.$oid)
        ]);

        const filteredDataByRestaurantId = allMenuRes.data.filter(
          (item) => item.id_Restaurants === userData._id.$oid
        );
        setPlates(filteredDataByRestaurantId);

        const matchingMenuItems = menuOfDayRes.data.filter(
          (item) => item.day === Day
        ).map((item) => item.id_menu);

        const filteredMenuItems = allMenuRes.data.filter((item) =>
          matchingMenuItems.includes(item._id.$oid)
        );
        setMenuItems(filteredMenuItems);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
        setIsDeleted(false);
        setIsAdded(false);
      }
    };

    fetchData();
  }, [Day, userData._id.$oid, selectedDay, isDeleted, isAdded]);

  const handleClick = () => {
    setShowModal(true);
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  const plateClicked = async (value) => {
    try {
      if (value._id && value._id.$oid) {
        await MenuOfTheDayService.addMenuOfTheDay({
          id_menu: value._id.$oid,
          id_restaurant: userData._id.$oid,
          day: Day,
        });
        message.success(`Prato adicionado ao dia de ${selectedDay} com sucesso!`);
        setShowModal(false);
        setIsAdded(true);
      } else {
        throw new Error("Invalid plate selection");
      }
    } catch (error) {
      console.error(error);
      message.error("Erro ao adicionar prato ao dia. Tente novamente mais tarde.");
    }
  };

  const confirm = async (itemMenuDay) => {
    try {
      const res = await MenuOfTheDayService.returnAllMenuOfDayByRestaurant(userData._id.$oid);
      const filteredData = res.data.filter(
        (item) => item.id_menu === itemMenuDay._id.$oid && item.day === Day
      );

      await Promise.all(filteredData.map(async (item) => {
        try {
          const deleteRes = await MenuOfTheDayService.deleteMenuOfTheDayById(item._id.$oid);
          console.log(deleteRes.msg);
          setIsDeleted(true);
        } catch (deleteErr) {
          console.error(deleteErr);
        }
      }));

      message.success("Prato retirado com sucesso");
    } catch (err) {
      console.error(err);
    }
  };

  const cancel = (e) => {
    console.log(e);
  };

  return (
    <Flex className="queue-simple" style={{
    }}>
      {loading ? (
        <div className="loading-container">
          <div class="spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      ) : (
        menuItems.length === 0 ? (
          <div key="empty-menu" className="empty-menu-calendar">
            <span className="empty-message">Vazio.</span>
            <Empty />
            <span className="empty-message-description">Adicione pratos ao dia desejado.</span>
          </div>
        ) : (
          menuItems.map((item, index) => (
            <Flex  key={index} className="menu-item-calendar">
              {/* <div className="item-image">
                <img src={item.img} alt="item image" />
              </div> */}
              <div className="item-details">
                <h3 className="item-name">{item.name}</h3>
                <p>{item.description}</p>
              </div>
              <div className="item-price">
                <Flex vertical justify={"space-evenly"} gap={"4vh"}>
                  <Popconfirm
                    onConfirm={() => confirm(item)}
                    onCancel={cancel}
                    title={`Quer retirar o prato de ${selectedDay}?`}
                    okText="Apagar"
                    placement="left"
                    cancelText="Cancelar"
                  >
                    <div className="threeDots_button_plates">
                      <img src={deleteIcon} alt="delete icon" />
                    </div>
                  </Popconfirm>
                  <p className="item-price-value">{item.price}€</p>
                </Flex>
              </div>
            </Flex>
          ))
        )
      )}
      <Button
        key="add-plate-button"
        icon={<PlusOutlined />}
        onClick={handleClick}
        className="add-plate-button-menu"
      >
        Adicionar novo prato
      </Button>
      <Modal
        open={showModal}
        onCancel={handleCancel}
        footer={null}
        centered
        style={{
          overflow: "auto"
        }}
      >
        {plates && <Plates plates={plates} plateClicked={plateClicked} />}
      </Modal>
    </Flex>
  );
};

export default MenuCalendar;
